export const iconFontAwesomeWritingQuoteRight = (
	<i className="fa-solid fa-quote-right"></i>
);
